import { render } from "./InputCelular.vue?vue&type=template&id=6e431b2b"
import script from "./InputCelular.vue?vue&type=script&lang=js"
export * from "./InputCelular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__